import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AuthService} from '../../../_services/auth/auth.service';

interface FileTypes {
  label: string;
  active: boolean;
}

@Component({
  selector: 'app-filter-files',
  templateUrl: './filter-files.component.html',
  styleUrls: ['./filter-files.component.scss']
})
export class FilterFilesComponent implements OnInit {
  @Input() browseDocumentTypes: string[];
  @Output() selectedType: EventEmitter<string> = new EventEmitter();
  types: FileTypes[];
  currentSelected;

  constructor(private auth: AuthService) { }

  ngOnInit(): void {
    let countAvailable = 0;
    this.types = [];

    this.auth.checkUserStatus().subscribe( res => {
      const availableModels = res.allowed_data_types;
      const showAllAnyway = (((availableModels.length === 1) && (this.browseDocumentTypes.length === 1) && (availableModels[0].label.toLowerCase() !== this.browseDocumentTypes[0].toLowerCase())) || (this.browseDocumentTypes.length > 1));
      Object.keys(availableModels).forEach( (key) => {
        this.types.push({label: availableModels[key].label.toLowerCase(), active: true});
        this.currentSelected = availableModels[key].label;
        countAvailable ++;
      });
      if (countAvailable > 1 || showAllAnyway) {
        const label = 'all';
        this.types.unshift({label, active: true});
        this.currentSelected = label;
      }
    });
  }

  select(newValue) {
    if (newValue.active) {
      this.currentSelected = newValue.label;
      this.selectedType.emit(this.currentSelected);
    }
  }

}
